export const ProductFillCredits = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM14.0833 9.91667C12.651 8.48438 12 5.75 12 5.75C12 5.75 11.349 8.48438 9.91667 9.91667C8.48438 11.349 5.75 12 5.75 12C5.75 12 8.56575 12.7324 9.91667 14.0833C11.2676 15.4342 12 18.25 12 18.25C12 18.25 12.5371 15.6296 14.0833 14.0833C15.6296 12.5371 18.25 12 18.25 12C18.25 12 15.5156 11.349 14.0833 9.91667Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
